import React, { useEffect } from 'react';
import Heading from './Header/Heading';
import MainSection from './MainSection/MainSection';
import Skills from './Skills/Skills';
import Work from './Works/Work';
import Contact from './Contact/Contact';
import Footer from './Footer/Footer';
import Copyright from './Copyrights/Copyright';

// AOS IMPORTING
import AOS from 'aos';
import 'aos/dist/aos.css';
import Process from './Process/Process';


function App() {
  useEffect(()=>{
    AOS.init({duration: 1000});
  },[]);

  return (
    <>
      <Heading></Heading>
      <MainSection></MainSection>
      <Skills></Skills>
      <Process></Process>
      <Work></Work>
      <Contact></Contact>
      <Footer></Footer>
      <Copyright></Copyright>
    </>
  )
}

export default App;
